export default __webpack_public_path__ + "static/media/editIcon.fec19944.svg";